/* ExiFlea Plus theme — vanilla JS, section-scoped.
   Every section initialises from its own root element (data-section-type) so it works with
   multiple instances and with the theme editor (shopify:section:load / unload). */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (root, sel) { return root.querySelector(sel); };
  var $$ = function (root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var cfg = window.ExiFlea || { routes: {} };
  var cleanups = {};

  function readJSON(root, sel) {
    var el = $(root, sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  /* Asset URLs inside JSON data are protocol-relative (//store.myshopify.com/cdn/...). `shopify theme dev` only rewrites URLs in HTML,
     so locally use the same-origin path (served through the dev proxy). Everywhere else load over https. */
  function assetSrc(src) {
    if (!src || src.indexOf('//') !== 0) return src;
    var h = window.location.hostname;
    if (h === '127.0.0.1' || h === 'localhost') {
      try { var u = new URL('https:' + src); return u.pathname + u.search; } catch (e) { /* fall through */ }
    }
    return 'https:' + src;
  }
  function svgIcon(id) {
    return '<svg aria-hidden="true" viewBox="0 0 48 48"><use href="#' + id + '"/></svg>';
  }
  function tick() {
    return '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 25.6 18.6 36 40 12.6"/></svg>';
  }
  function lines(str) {
    return String(str || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
  }

  /* ---------------- header (nav, search, cart count) ---------------- */
  function initHeader(root) {
    var toggle = $(root, '#navtoggle'), nav = $(root, '#nav');
    var search = $(root, '#hdrsearch'), sBtn = $(root, '#searchtoggle');

    function setOffset() {
      document.documentElement.style.setProperty('--hdr-h', root.offsetHeight + 'px');
    }
    setOffset();
    window.addEventListener('resize', setOffset);

    function onScroll() { root.classList.toggle('is-scrolled', window.scrollY > 8); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    function closeNav() {
      nav.setAttribute('data-open', 'false');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Menu';
    }
    toggle.addEventListener('click', function () {
      var open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.textContent = !open ? 'Close' : 'Menu';
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a') && window.innerWidth <= 940) closeNav();
    });

    if (sBtn && search) {
      sBtn.addEventListener('click', function () {
        var open = search.hidden;
        search.hidden = !open;
        sBtn.setAttribute('aria-expanded', String(open));
        if (open) { var q = $(search, 'input[type=search]'); if (q) q.focus(); }
      });
    }

    var cartLink = $(root, '#carttoggle');
    if (cartLink && cfg.cartDrawer) {
      cartLink.addEventListener('click', function (e) {
        if (!document.getElementById('cartdrawer')) return;
        e.preventDefault();
        openDrawer();
      });
    }
  }

  function setCartCount(n) {
    var el = document.getElementById('cartcount');
    if (!el) return;
    el.textContent = n;
    el.setAttribute('data-count', n);
    el.hidden = !n;
  }

  /* ---------------- search input reset on back navigation ---------------- */
  function clearSearchInputs() {
    var inputs = document.querySelectorAll('input[type="search"][name="q"], input[name="q"]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].value = '';
    }
  }

  function handleBackNavigation() {
    var isBack = false;
    try {
      var navEntries = window.performance && window.performance.getEntriesByType ? window.performance.getEntriesByType('navigation') : [];
      if (navEntries && navEntries.length > 0) {
        isBack = (navEntries[0].type === 'back_forward');
      } else if (window.performance && window.performance.navigation) {
        isBack = (window.performance.navigation.type === 2);
      }
    } catch (e) {}

    if (isBack) {
      clearSearchInputs();
    }
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      clearSearchInputs();
    } else {
      handleBackNavigation();
    }
  });

  window.addEventListener('popstate', function () {
    clearSearchInputs();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleBackNavigation);
  } else {
    handleBackNavigation();
  }

  /* ---------------- cart drawer + cart API ---------------- */
  var lastFocus = null;
  function openDrawer() {
    var d = document.getElementById('cartdrawer');
    if (!d) return;
    lastFocus = document.activeElement;
    document.body.classList.add('drawer-open');
    d.focus();
  }
  function closeDrawer() {
    document.body.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshDrawer() {
    return fetch(cfg.routes.root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = $(tmp, '#cartdrawer');
        var cur = document.getElementById('cartdrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      });
  }
  function refreshCart() {
    return fetch(cfg.routes.cartJson, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; });
  }

  function addToCart(variantId, qty) {
    return fetch(cfg.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty) || 1 }] })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error(body.description || body.message || 'Could not add to cart');
        return body;
      });
    }).then(function () {
      return Promise.all([refreshCart(), cfg.cartDrawer ? refreshDrawer() : null]);
    }).then(function () {
      if (cfg.cartDrawer && document.getElementById('cartdrawer')) openDrawer();
      else window.location.href = cfg.routes.cart;
    });
  }

  function changeLine(line, qty, onDone) {
    return fetch(cfg.routes.cartChange, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      setCartCount(cart.item_count);
      return onDone(cart);
    });
  }

  /* Delegated handlers: one set for the drawer and the cart page. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-drawer-close]')) { closeDrawer(); return; }

    var step = t.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('.qty'), input = $(wrap, 'input');
      var min = input.hasAttribute('data-qty') ? 1 : 0;
      var next = Math.max(min, (parseInt(input.value, 10) || 0) + Number(step.getAttribute('data-qty-step')));
      input.value = next;
      if (input.hasAttribute('data-line-qty')) input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var rm = t.closest('[data-line-remove]');
    if (rm) {
      var item = rm.closest('.citem');
      if (!item || !window.fetch) return;
      e.preventDefault();
      updateLine(item, 0);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('drawer-open')) closeDrawer();
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('[data-line-qty]') : null;
    if (!input || !window.fetch) return;
    updateLine(input.closest('.citem'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  function updateLine(item, qty) {
    var line = item.getAttribute('data-line');
    var inDrawer = !!item.closest('#cartdrawer');
    item.style.opacity = '.5';
    changeLine(line, qty, function () {
      if (inDrawer) return refreshDrawer();
      window.location.reload();
    }).catch(function () { item.style.opacity = ''; });
  }

  /* ---------------- hero ---------------- */
  function initHero(root) {
    var imgs = $$(root, '.stage2__pet img');
    var packs = $$(root, '[data-hero-packs]');
    var seconds = parseFloat(root.getAttribute('data-hero-interval')) || 6;
    var species = 'dog', timer = null;

    function set(next) {
      species = next;
      var dog = next === 'dog';
      if (imgs[0]) { imgs[0].classList.toggle('on', dog); imgs[0].setAttribute('aria-hidden', String(!dog)); }
      if (imgs[1]) { imgs[1].classList.toggle('on', !dog); imgs[1].setAttribute('aria-hidden', String(dog)); }
      packs.forEach(function (g) { g.hidden = g.getAttribute('data-hero-packs') !== next; });
    }
    function start() {
      if (REDUCED || timer) return;
      timer = setInterval(function () { set(species === 'dog' ? 'cat' : 'dog'); }, seconds * 1000);
    }
    function stop() { clearInterval(timer); timer = null; }
    function onVisibility() { if (document.hidden) stop(); else start(); }

    set('dog');
    start();
    document.addEventListener('visibilitychange', onVisibility);
    return function () { stop(); document.removeEventListener('visibilitychange', onVisibility); };
  }

  /* ---------------- "one drop, three jobs" fork ---------------- */
  function initFork(root) {
    var svg = $(root, '[data-fork]');
    if (!svg) return;
    var paths = $$(svg, '[data-fork-path]');
    var nodes = $(svg, '[data-fork-nodes]');
    paths.forEach(function (p) {
      var L = p.getTotalLength();
      p.style.strokeDasharray = L;
      p.style.strokeDashoffset = REDUCED ? 0 : L;
    });
    if (REDUCED || !('IntersectionObserver' in window)) { nodes.setAttribute('opacity', '1'); paths.forEach(function (p) { p.style.strokeDashoffset = 0; }); return; }
    var done = false, timer;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && !done) {
          done = true;
          paths.forEach(function (p, i) {
            p.style.transition = 'stroke-dashoffset .85s cubic-bezier(.3,.8,.4,1) ' + (i === 0 ? 0 : 0.35) + 's';
            p.style.strokeDashoffset = 0;
          });
          timer = setTimeout(function () { nodes.style.transition = 'opacity .5s ease'; nodes.style.opacity = 1; }, 1000);
        }
      });
    }, { threshold: 0.4 });
    io.observe(svg);
    return function () { io.disconnect(); clearTimeout(timer); };
  }

  /* ---------------- pack finder ---------------- */
  function initPackFinder(root) {
    var data = readJSON(root, '[data-pf-data]');
    if (!data) return;
    var cleanupFns = [];
    var wrap = $(root, '[data-pf-root]');
    var el = {};
    $$(root, '[data-pf]').forEach(function (n) { el[n.getAttribute('data-pf')] = n; });
    var species = 'dog';

    /* ---- checkout popup: collects details, then sends the shopper to Shopify checkout with only this pack ---- */
    var STATES = { ACT: 'Australian Capital Territory', NSW: 'New South Wales', NT: 'Northern Territory', QLD: 'Queensland',
                   SA: 'South Australia', TAS: 'Tasmania', VIC: 'Victoria', WA: 'Western Australia' };
    var checkout = (function () {
      var ov = $(root, '[data-co="overlay"]');
      if (!ov) return { open: function (p) { addToCart(p.variant, 1); } };
      var f = {};
      $$(ov, '[data-co]').forEach(function (n) { f[n.getAttribute('data-co')] = n; });
      var pack = null, lastFocus = null, busy = false;
      var money;
      try { money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: data.currency || 'AUD' }); } catch (e) { money = null; }
      function fmt(cents) { return money ? money.format(cents / 100) : (cents / 100).toFixed(2); }

      function qtyVal() { return Math.max(1, Math.min(99, parseInt(f.qty.value, 10) || 1)); }
      function setQty(n) {
        n = Math.max(1, Math.min(99, n || 1));
        f.qty.value = n;
        f.packs.textContent = '(' + n + (n === 1 ? ' pack' : ' packs') + ')';
        var ship = data.shippingCents || 0;
        f.ship.textContent = ship ? fmt(ship) : 'Calculated at checkout';
        f['total-label'].textContent = ship ? 'Total' : 'Subtotal';
        if (pack && pack.priceCents) {
          f.line.textContent = fmt(pack.priceCents * n);
          f.total.textContent = fmt(pack.priceCents * n + ship);
        } else { f.line.textContent = f.total.textContent = '—'; }
      }
      function showError(msg) { f.error.textContent = msg || ''; f.error.hidden = !msg; }
      function setBusy(on) {
        busy = on;
        f.submit.disabled = on;
        f['submit-label'].textContent = on ? 'Please wait…' : f['submit-label'].getAttribute('data-label');
      }
      f['submit-label'].setAttribute('data-label', f['submit-label'].textContent);

      function open(p, trigger) {
        pack = p; lastFocus = trigger || document.activeElement;
        f.img.src = assetSrc(p.img); f.img.alt = p.alt || p.name; f.name.textContent = p.name;
        f.form.hidden = false; f.done.hidden = true; showError('');
        setBusy(false); setQty(1);
        ov.setAttribute('data-open', 'true'); ov.setAttribute('aria-hidden', 'false');
        document.body.classList.add('co-open');
        setTimeout(function () { f.fullname.focus(); }, 60);
      }
      function close() {
        if (busy) return;
        ov.setAttribute('data-open', 'false'); ov.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('co-open');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      function isOpen() { return ov.getAttribute('data-open') === 'true'; }

      f.close.addEventListener('click', close);
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
      var onKey = function (e) {
        if (!isOpen()) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'Tab') {   /* keep focus inside the dialog */
          var items = $$(ov, 'button:not([disabled]), input:not([type=hidden]), select, textarea, [href]').filter(function (n) { return n.offsetParent !== null; });
          if (!items.length) return;
          var first = items[0], last = items[items.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      };
      document.addEventListener('keydown', onKey);
      cleanupFns.push(function () { document.removeEventListener('keydown', onKey); document.body.classList.remove('co-open'); });

      f.minus.addEventListener('click', function () { setQty(qtyVal() - 1); });
      f.plus.addEventListener('click', function () { setQty(qtyVal() + 1); });
      f.qty.addEventListener('input', function () { f.qty.value = f.qty.value.replace(/[^0-9]/g, ''); });
      f.qty.addEventListener('blur', function () { setQty(parseInt(f.qty.value, 10) || 1); });

      function markInvalid(el) {
        el.focus();
        el.style.borderColor = '#CC5B45'; el.style.boxShadow = '0 0 0 3px rgba(204,91,69,.14)';
        var h = function () { el.style.borderColor = ''; el.style.boxShadow = ''; el.removeEventListener('input', h); el.removeEventListener('change', h); };
        el.addEventListener('input', h); el.addEventListener('change', h);
      }

      f.form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy || !pack) return;
        var bad = f.form.querySelector(':invalid');
        if (bad) { markInvalid(bad); showError('Please check the highlighted field.'); return; }
        showError('');

        var full = f.fullname.value.trim().replace(/\s+/g, ' ');
        var sp = full.indexOf(' ');
        var first = sp > 0 ? full.slice(0, sp) : full, last = sp > 0 ? full.slice(sp + 1) : '';
        var phone = '+61' + f.phone.value.replace(/\D/g, '').replace(/^0/, '');
        var qty = qtyVal();
        var notes = f.notes.value.trim();

        setBusy(true);
        /* 1. empty the cart so checkout contains only this pack  2. add the pack  3. attach notes  4. go to checkout */
        fetch(cfg.routes.cartClear, { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('Could not start checkout. Please try again.'); })
          .then(function () {
            return fetch(cfg.routes.cartAdd, {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(pack.variant), quantity: qty }] })
            });
          })
          .then(function (r) {
            return r.json().then(function (b) {
              if (!r.ok) throw new Error(b.description || b.message || 'This pack could not be added to your order.');
            });
          })
          .then(function () {
            return fetch(cfg.routes.cartUpdate, {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ note: notes, attributes: { 'Mobile': phone } })
            });
          })
          .then(function () {
            var q = new URLSearchParams();
            q.set('checkout[email]', f.email.value.trim());
            if (f.same.checked) {
              q.set('checkout[shipping_address][first_name]', first);
              q.set('checkout[shipping_address][last_name]', last);
              q.set('checkout[shipping_address][address1]', f.address.value.trim());
              q.set('checkout[shipping_address][city]', f.city.value.trim());
              q.set('checkout[shipping_address][province]', STATES[f.state.value] || f.state.value);
              q.set('checkout[shipping_address][zip]', f.postcode.value.trim());
              q.set('checkout[shipping_address][country]', 'Australia');
              q.set('checkout[shipping_address][phone]', phone);
            }
            f.form.hidden = true; f.done.hidden = false;
            window.location.href = cfg.routes.checkout + '?' + q.toString();
          })
          .catch(function (err) { setBusy(false); showError(err.message || 'Something went wrong. Please try again.'); });
      });

      return { open: open };
    })();

    function packs() { return data.species[species].packs; }
    function currentIndex(w) {
      var set = packs();
      for (var i = 0; i < set.length; i++) { if (w <= set[i].upTo) return i; }
      return set.length - 1;
    }
    function buildTrack() {
      var set = packs(), prev = 0;
      var spans = set.map(function (p) { var s = Math.max(1, p.upTo - prev); prev = p.upTo; return s; });
      el.track.innerHTML = set.map(function (p, i) { return '<i style="flex:' + spans[i] + ';background:' + p.color + '"></i>'; }).join('');
      el.ticks.innerHTML = set.map(function (p, i) { return '<i style="flex:' + spans[i] + '">' + p.label + ' kg</i>'; }).join('');
      var max = data.species[species].max;
      el.range.max = max;
      el.range.value = species === 'dog' ? Math.min(18, max) : Math.min(5, max);
    }
    function render() {
      var set = packs();
      if (!set.length) return;
      var max = data.species[species].max;
      var w = +el.range.value, i = currentIndex(w), p = set[i];
      wrap.style.setProperty('--sku', p.color);
      el.val.innerHTML = w + (w >= max ? '+' : '') + '<small>kg</small>';
      el.img.src = assetSrc(p.img); el.img.alt = p.alt || '';
      el.tag.textContent = p.tag; el.name.textContent = p.name;
      el.meta.innerHTML = '';
      var b = document.createElement('b'); b.textContent = p.tubes;
      el.meta.appendChild(b);
      el.meta.appendChild(document.createTextNode(' · ' + p.actives));
      el.list.innerHTML = '';
      lines(data.species[species].covers).forEach(function (t) {
        var li = document.createElement('li');
        li.innerHTML = tick();
        var s = document.createElement('span'); s.textContent = t;
        li.appendChild(s); el.list.appendChild(li);
      });
      $$(el.track, 'i').forEach(function (n, k) { n.classList.toggle('on', k === i); });
      $$(el.ticks, 'i').forEach(function (n, k) { n.classList.toggle('on', k === i); });
      renderBuy(p);
    }
    function renderBuy(p) {
      var a = el.buy, add = el.add;
      a.removeAttribute('data-variant'); a.removeAttribute('aria-disabled');
      a.onclick = null; add.onclick = null; add.hidden = true;
      el.price.textContent = p.price || '';
      if (p.url && !p.available) {
        a.textContent = data.soldOutLabel; a.setAttribute('aria-disabled', 'true'); a.href = p.url;
        a.onclick = function (e) { e.preventDefault(); };
      } else if (p.url && p.variant) {
        a.textContent = data.buttonLabel; a.href = p.url;
        a.setAttribute('data-variant', p.variant);
        a.onclick = function (e) { e.preventDefault(); checkout.open(p, a); };
        add.hidden = false; add.textContent = data.addLabel; add.disabled = false;
        add.onclick = function () {
          if (add.disabled) return;
          add.disabled = true; add.textContent = 'Adding…';
          addToCart(p.variant, 1).catch(function (err) { window.alert(err.message); })
            .then(function () { add.disabled = false; add.textContent = data.addLabel; });
        };
      } else {
        a.textContent = data.buttonLabel; a.href = p.url || data.fallbackLink;
      }
    }
    function setSpecies(s) {
      species = s;
      $$(root, '[data-pf-switch]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-pf-switch') === s)); });
      buildTrack(); render();
    }
    $$(root, '[data-pf-switch]').forEach(function (b) {
      b.addEventListener('click', function () { setSpecies(b.getAttribute('data-pf-switch')); });
    });
    el.range.addEventListener('input', render);
    setSpecies('dog');
    return function () { cleanupFns.forEach(function (fn) { fn(); }); };
  }

  /* ---------------- "how fast" scrubber ---------------- */
  function initSpeed(root) {
    var steps = readJSON(root, '[data-sp-data]');
    if (!steps || !steps.length) return;
    var el = {};
    $$(root, '[data-sp]').forEach(function (n) { el[n.getAttribute('data-sp')] = n; });
    var N = 40, html = '';
    for (var i = 0; i < N; i++) html += '<span class="fleacell"><svg viewBox="0 0 48 48" aria-hidden="true"><use href="#i-flea"/></svg></span>';
    el.grid.innerHTML = html;
    var maxIdx = Math.max(1, steps.length - 1);
    el.stops.innerHTML = steps.map(function (s, i) {
      var pct = i / maxIdx;
      var leftStyle = 'left:calc(12px + ' + (pct * 100).toFixed(4) + '% - ' + (pct * 24).toFixed(4) + 'px);';
      return '<i style="' + leftStyle + '" data-step="' + i + '">' + s.big + '</i>';
    }).join('');
    function render() {
      var v = +el.range.value, s = steps[v];
      if (!s) return;
      el.step.textContent = s.big; el.when.textContent = s.when; el.copy.textContent = s.copy;
      el.key.style.color = s.key; el.count.textContent = s.keyTxt;
      $$(el.grid, '.fleacell').forEach(function (cell, n) {
        var alive = n < s.alive, killedShown = !alive && s.crossed;
        var svg = $(cell, 'svg');
        svg.style.opacity = alive ? 1 : (killedShown ? 0.55 : 0.12);
        svg.style.color = alive ? (s.fed ? '#DC091E' : '#F3AC41') : (killedShown ? '#8FB79C' : '#0A5138');
        svg.style.transform = alive ? 'none' : 'scale(.8)';
        cell.classList.toggle('killed', killedShown);
      });
      $$(el.stops, 'i').forEach(function (n, k) { n.classList.toggle('on', k === v); });
    }
    el.range.addEventListener('input', render);
    el.stops.addEventListener('click', function (e) {
      var target = e.target.closest('i[data-step]');
      if (!target) return;
      var stepIdx = +target.getAttribute('data-step');
      if (!isNaN(stepIdx)) {
        el.range.value = stepIdx;
        render();
      }
    });
    render();
  }

  /* ---------------- comparison switch ---------------- */
  function initComparison(root) {
    var bite = $(root, '[data-ab-bite]'), contact = $(root, '[data-ab-contact]'), verdict = $(root, '[data-ab-verdict]');
    var btns = $$(root, '[data-ab-switch]');
    bite.style.transition = contact.style.transition = 'opacity .3s ease';
    function set(k) {
      bite.setAttribute('opacity', k === 'other' ? '1' : '0');
      contact.setAttribute('opacity', k === 'ours' ? '1' : '0');
      btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-ab-switch') === k)); });
      verdict.innerHTML = '';
      var b = document.createElement('b'); b.textContent = verdict.getAttribute('data-' + k + '-title');
      verdict.appendChild(b);
      verdict.appendChild(document.createTextNode(verdict.getAttribute('data-' + k + '-text')));
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-ab-switch')); }); });
    set('ours');
  }

  /* ---------------- parasite body map ---------------- */
  var SITES = {
    dog: { coat: [22.3, 20.2], ear: [37.4, 16.0], heart: [30.7, 26.2], gut: [24.0, 29.2] },
    cat: { coat: [19.2, 24.0], ear: [33.0, 10.3], heart: [31.2, 21.7], gut: [25.8, 30.1], lung: [30.0, 17.9] }
  };
  var BODY_BOX = { dog: [3, 10, 42, 30], cat: [9, 5, 30, 38] };

  function initParasiteMap(root) {
    var img = $(root, '[data-bm-img]'), pinLayer = $(root, '[data-bm-pins]'), note = $(root, '[data-bm-note]');
    var items = $$(root, '[data-bm-item]');
    var species = 'dog', open = null;
    var NS = 'http://www.w3.org/2000/svg';

    function visible(it) { var sp = it.getAttribute('data-species'); return sp === 'both' || sp === species; }
    function body(it) { return document.getElementById('pb-' + it.getAttribute('data-bm-item')); }

    function renderPins() {
      var sites = SITES[species], used = {};
      items.forEach(function (it) { if (visible(it) && sites[it.getAttribute('data-site')]) used[it.getAttribute('data-site')] = true; });
      pinLayer.innerHTML = '';
      Object.keys(used).forEach(function (site) {
        var c = sites[site];
        var g = document.createElementNS(NS, 'g');
        g.setAttribute('class', 'pinG'); g.setAttribute('data-site', site);
        g.setAttribute('transform', 'translate(' + c[0] + ',' + c[1] + ')');
        g.innerHTML = '<circle class="halo" r="2.6"/><circle class="dot" r="1"/>';
        g.addEventListener('click', function () {
          var first = items.filter(function (it) { return visible(it) && it.getAttribute('data-site') === site; })[0];
          if (first) toggle(first, false);
        });
        pinLayer.appendChild(g);
      });
    }
    function paint() {
      items.forEach(function (it) {
        var show = visible(it), on = show && open === it;
        it.hidden = !show;
        it.setAttribute('aria-expanded', String(on));
        body(it).hidden = !on;
      });
      var site = open && open.getAttribute('data-site');
      $$(pinLayer, '.pinG').forEach(function (g) { g.classList.toggle('on', g.getAttribute('data-site') === site); });
      if (open) {
        note.innerHTML = '';
        var b = document.createElement('b'); b.textContent = open.getAttribute('data-name') + ' — ' + open.getAttribute('data-where');
        note.appendChild(b); note.appendChild(document.createTextNode(open.getAttribute('data-note') || ''));
      } else {
        note.innerHTML = note.getAttribute('data-default');
      }
    }
    function toggle(it, allowClose) {
      open = (allowClose && open === it) ? null : it;
      paint();
    }
    function setSpecies(s) {
      species = s; open = null;
      $$(root, '[data-bm-switch]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-bm-switch') === s)); });
      var box = BODY_BOX[s];
      img.setAttribute('href', img.getAttribute('data-' + s));
      ['x', 'y', 'width', 'height'].forEach(function (a, k) { img.setAttribute(a, box[k]); });
      renderPins(); paint();
    }
    items.forEach(function (it) { it.addEventListener('click', function () { toggle(it, true); }); });
    $$(root, '[data-bm-switch]').forEach(function (b) { b.addEventListener('click', function () { setSpecies(b.getAttribute('data-bm-switch')); }); });
    setSpecies('dog');
  }

  /* ---------------- product page ---------------- */
  function initProduct(root) {
    var form = $(root, '[data-product-form]');
    if (!form) return;
    var sel = $(form, '[data-variant-select]'), btn = $(form, '[data-add-btn]');
    var qty = $(form, '[data-qty]'), msg = $(form, '[data-prod-msg]'), price = $(root, '[data-prod-price]');
    var main = $(root, '[data-prod-main]');

    $$(root, '[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var im = $(main, 'img');
        if (im) { im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = t.getAttribute('data-thumb'); im.alt = t.getAttribute('data-alt'); }
        $$(root, '[data-thumb]').forEach(function (o) { o.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    if (sel && sel.tagName === 'SELECT') {
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        var cmp = +o.getAttribute('data-compare-raw') > +o.getAttribute('data-price-raw');
        price.innerHTML = '';
        price.appendChild(document.createTextNode(o.getAttribute('data-price')));
        if (cmp) { var s = document.createElement('s'); s.textContent = o.getAttribute('data-compare'); price.appendChild(s); }
        var ok = o.getAttribute('data-available') === 'true';
        btn.disabled = !ok; btn.textContent = ok ? 'Add to cart' : 'Sold out';
        var u = new URL(window.location.href); u.searchParams.set('variant', o.value);
        window.history.replaceState({}, '', u.toString());
      });
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (btn.disabled) return;
      msg.textContent = ''; msg.className = 'prod__msg';
      var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
      addToCart(sel.value, qty.value).catch(function (err) {
        msg.textContent = err.message; msg.className = 'prod__msg err';
      }).then(function () { btn.disabled = false; btn.textContent = label; });
    });
  }

  /* ---------------- section registry ---------------- */
  var INIT = {
    'header': [initHeader],
    'hero': [initHero],
    'three-jobs': [initFork],
    'pack-finder': [initPackFinder],
    'speed': [initSpeed],
    'comparison': [initComparison],
    'parasite-map': [initParasiteMap],
    'product': [initProduct]
  };

  function mount(container) {
    $$(container, '[data-section-type]').concat(container.matches && container.matches('[data-section-type]') ? [container] : [])
      .forEach(function (root) {
        var type = root.getAttribute('data-section-type');
        if (root.__mounted) return;
        root.__mounted = true;
        (INIT[type] || []).forEach(function (fn) {
          var off = fn(root);
          if (typeof off === 'function') {
            var id = root.getAttribute('data-section-id') || type;
            (cleanups[id] = cleanups[id] || []).push(off);
          }
        });
      });
  }
  function unmount(id) {
    (cleanups[id] || []).forEach(function (off) { off(); });
    delete cleanups[id];
  }

  function boot() { mount(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-section-id]') || e.target;
    unmount(root.getAttribute('data-section-id'));
  });
})();
